// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__29cbN","title":"ClientInsurance_title__FWugn","itemText":"ClientInsurance_itemText__3CB-P"};